<script setup>
import { ref, watch } from 'vue'
import api from '@/api/api'
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import Dialog from '@/components/Dialog.vue'
import { useDialog } from '@/utils/dialog'

const { openDialog } = useDialog()

const searchFrom = ref({
    title: '',
    page: 1,
    pageSize: 5,
    total: 0
})
const tableData = ref([])
const showMain = ref(false)

watch(showMain, e => {
    if (e) {
        getList()
    }
})

// 查看
const handOpen = (row, index) => {
    const closeDialog = openDialog(Dialog, {
        type: 'preview',
        data: { ...row },
        onConfirm: () => {
            closeDialog()
        }
    })
}

const handleSizeChange = function (val) {
    searchFrom.value.page = 1
    searchFrom.value.pageSize = val
    getList()
}
const handleCurrentPageChange = function (val) {
    searchFrom.value.page = val
    getList()
}

// 获取公告列表 传入status表示搜索查询
const getList = () => {
    api.noticeUserList(searchFrom.value).then(result => {
        console.log(result)
        if (result.data.list) {
            tableData.value = result.data.list
            searchFrom.value.total = result.data.total
        }
    })
}
// 格式化日期
const formatDateTime = date => {
    try {
        let time = date.split(' ')
        return time[0] || date.create_time
    } catch (e) {
        return date
    }
}

defineExpose({
    showMain
})
</script>

<template>
    <el-dialog v-model="showMain" title="历史公告" width="1000" :z-index="998">
        <div class="notice_view">
            <div class="searchBox">
                <el-input placeholder="公告标题" v-model="searchFrom.title" clearable />
                <el-button type="primary" @click="handleCurrentPageChange(1)">
                    <el-icon>
                        <Search />
                    </el-icon>
                    搜索
                </el-button>
            </div>
            <el-table :data="tableData" style="width: 100%">
                <el-table-column fixed type="index" label="序号" align="center" width="60" />
                <el-table-column prop="title" label="公告标题" align="center" />
                <el-table-column prop="create_time" width="140" label="发布日期" align="center">
                    <template #default="{ row }">
                        {{ formatDateTime(row.create_time) }}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center" width="180">
                    <template #default="{ $index, row }">
                        <el-button type="primary" size="small" @click="handOpen(row, $index)">
                            查看
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-row justify="start" style="margin-top: 16px">
                <el-pagination
                    v-model:current-page="searchFrom.page"
                    background
                    :total="searchFrom.total"
                    v-model:page-size="searchFrom.pageSize"
                    :page-sizes="[5, 10, 20]"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentPageChange"
                    layout="total, prev, pager, next,sizes"
                />
            </el-row>
        </div>
    </el-dialog>
</template>

<style scoped lang="scss">
.notice_view {
    width: 100%;
    overflow: hidden;

    .content {
        overflow: hidden;
    }
}
</style>
